import {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
} from "@mui/material";
import undoImg from "../../assets/images/undo.svg";
import downloadButton from  "../../assets/images/downloadButton.svg"
import redoImg from "../../assets/images/redo.svg";
import Footer from "../Footer/Footer";
import PushButton from "../../assets/images/PushButton.svg";
import SpeakerButton from "../../assets/images/SpeakerButton.svg";
import strobeButton from "../../assets/images/strobeButton.svg";
import cameraButton from "../../assets/images/cameraButton.svg";
import cameraPushButton from "../../assets/images/cameraPushbutton.svg";
import cameraInstalledFilled from "../../assets/images/camera-installed-filled.svg";
import collectionPoint from "../../assets/images/collectionPoint.svg";
import speakerStrobe from "../../assets/images/speakerStrobe.svg";
import speakerInstalled from "../../assets/images/speaker-installed.svg";
import controlPanel from "../../assets/images/control-panel-filled.svg";
import DeleteModal from './DeleteModal';
import AccessibleTooltip from "../Tooltip/Tooltip";
import {downloadFloorBlueprint} from '../../Actions/FloorManagementAction';
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import "./AddDevices.scss";
import "./floorMang.scss"
import { useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AddDevices = () => {
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState();
  const [expand, setExpand] = useState(true);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [sideberItemDisabled, setSideberItemDisabled] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [dynamicFooterList, setDynamicFooterList] = useState([]);
  const [announcementMessage, setAnnouncementMessage] = useState();
  const {deviceTypes, dowbloadBlueprintSuccess} = useSelector((state) => state.addEditDevice);

  const blueprintRef = useRef(null);
  const blueprintmainWrapperRef = useRef(null);
  const { id } = useParams();
  const columns = [
    {
      field: "Device",
      headerName: "Device",
      sortable: false,
      disableColumnMenu: true,
      hideable: false,
      renderCell: (params) => {
        let deviceImage = "";
        if (params.row.Type === "Camera") {
          deviceImage = cameraButton;
        } else if (params.row.Type === "Speaker") {
          deviceImage = SpeakerButton;
        } else if (params.row.Type === "Strobe Light") {
          deviceImage = strobeButton;
        } else if (params.row.Type === "Push-Button") {
          deviceImage = PushButton;
        } else if(params.row.Type === "Push Button Camera") {
          deviceImage = cameraPushButton;
        } else if(params.row.Type === "Speaker Strobe") {
          deviceImage = speakerStrobe;
        } else if(params.row.Type.toString().toLowerCase() === "control panel") {
          deviceImage = controlPanel;
        } else if(params.row.Type.toString().toLowerCase() === "installed camera") {
          deviceImage = cameraInstalledFilled;
        } else if(params.row.Type.toString().toLowerCase() === "installed speaker") {
          deviceImage = speakerInstalled;
        } else if(params.row.Type.toString().toLowerCase() === "collection point") {
          deviceImage = collectionPoint;
        }

        return (
          <div>
            <img src={deviceImage} alt={`${params.row.Type} image`} className="blurPrintLink" />
          </div>
        );
      },
    },
    {
      field: "DeviceName",
      headerName: "Name",
      flex: 1,
      hideable: false,
    },
    {
      field: "Type",
      headerName: "Type",
      flex: 1,
      hideable: false,
    },
  ];


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
  if (dowbloadBlueprintSuccess) {
    setAnnouncementMessage("Blueprint Downloaded");
    const timer = setTimeout(() => {
      dispatch({ type: "RESET_DOWNLOAD_BLUEPRINT_SUCCESS" });
      setAnnouncementMessage("");
    }, 1500);
    return () => clearTimeout(timer);
  }
}, [dowbloadBlueprintSuccess, dispatch]);

  const handleImageLoad = () => {
    setIsLoading(false);
    setTimeout(() => setIsTransitioning(false), 10000);
  };
  const saveState = useCallback(
    (newItems) => {
      setUndoStack((prevStack) => [...prevStack, items]);
      setItems(newItems);
      setRedoStack([]);
    },
    [items]
  );

  useEffect(() =>{
    if(deviceTypes){
      setDynamicFooterList(deviceTypes.data)
    }
  },[deviceTypes])
  const onDragStart = useCallback(
    (e, params) => {
      const dragData = {
        id: params.row.id,
        name: params.row.name,
        cssXCoordinate: params.row.cssXCoordinate,
        cssYCoordinate: params.row.cssYCoordinate,
        type: params.row.type,
        deviceLocationName: selectedFloor?.floorName,
        deviceLocationId: selectedFloor?.id,
        triggeredByDeviceId: [0],
        deleted: false,
        createdAt: params.row.createdAt,
        modifiedAt: new Date().toISOString(),
        createdBy: params.row.createdBy,
        niagaraDeviceName:params.row.niagaraDeviceName,
        modifiedBy: 0,
        triggeredBy: params.row.triggeredBy,
        deviceMake: params.row.deviceMake,
        status: params.row.status,
        serialNumber: params.row.serialNumber,
        installed: params.row.installed,
        macAddress: params.row.macAddress,
        ipAddress: params.row.ipAddress,
        topicName: params.row.topicName,
        cameraType: params.row.cameraType,
        streamUrl: params.row.streamUrl,
        videoLength: params.row.videoLength,
      };
      // Serialize only dragData (no circular references)
      e.dataTransfer.setData("droppedItem", JSON.stringify(dragData));
    },
    [selectedFloor]
  );
  const onDraggedStart = useCallback(
    (e, params) => {
      setOpenTooltipId(null)
      const dragData = {
        id: params.id,
        name: params.name,
        cssXCoordinate: params.cssXCoordinate,
        cssYCoordinate: params.cssYCoordinate,
        type: params.type,
        deviceLocationName: selectedFloor?.floorName,
        deviceLocationId: selectedFloor?.id,
        triggeredByDeviceId: [0],
        deleted: false,
        createdAt: params.createdAt,
        modifiedAt: new Date().toISOString(),
        createdBy: params.createdBy,
        modifiedBy: 0,
        triggeredBy: params.triggeredBy,
        niagaraDeviceName:params.niagaraDeviceName,
        deviceMake: params.deviceMake,
        status: params.status,
        serialNumber: params.serialNumber,
        installed: params.installed,
        macAddress: params.macAddress,
        ipAddress: params.ipAddress,
        topicName: params.topicName,
        cameraType: params.cameraType,
        streamUrl: params.streamUrl,
        videoLength: params.videoLength,
      };
      // Serialize only dragData (no circular references)
      e.dataTransfer.setData("droppedItem", JSON.stringify(dragData));
    },
    [selectedFloor]
  );


  const updateDeviceCoordinates = async (device) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const decodedToken = jwtDecode(token);
      const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/update/${device.id}`;
      const payload = {
        id: device.id,
        name: device.name,
        cssXCoordinate: device.cssXCoordinate,
        cssYCoordinate: device.cssYCoordinate,
        type: device.type,

        deviceLocationName: selectedFloor?.floorName,
        deviceLocationId: selectedFloor?.id,
        triggeredByDeviceId: [0],
        deleted: false,
        createdAt: device.createdAt,
        modifiedAt: new Date().toISOString(),
        createdBy: device.createdBy,
        modifiedBy: decodedToken.userGuid,
        niagaraDeviceName:device.niagaraDeviceName,
        triggeredBy: device.triggeredBy,
        deviceMake: device.deviceMake,
        status: device.status,
        serialNumber: device.serialNumber,
        installed: device.installed,
        macAddress: device.macAddress,
        ipAddress: device.ipAddress,
        topicName: device.topicName,
        cameraType: device.cameraType,
        streamUrl: device.streamUrl,
        videoLength: device.videoLength,
      };
      return await axios.put(url, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Error updating device coordinates:", error);
    }
  };



const onDrop = useCallback(
  async (e) => {
    e.preventDefault();

    const droppedItemDataString = e.dataTransfer.getData("droppedItem");
    const droppedItem = JSON.parse(droppedItemDataString);

    const blueprintRect = blueprintRef.current.getBoundingClientRect();

    // Exact cursor position inside blueprint
    let xOffset = e.clientX - blueprintRect.left;
    let yOffset = e.clientY - blueprintRect.top;

    // Keep inside bounds but with minimal margin
    const boundaryMargin = 0; // set to 0 for exact placement
    xOffset = Math.min(Math.max(xOffset, boundaryMargin), blueprintRect.width - boundaryMargin - 0);
    yOffset = Math.min(Math.max(yOffset, boundaryMargin), blueprintRect.height - boundaryMargin - 0);

    // Convert to percentage only for saving
  //  const newX = (xOffset / blueprintRect.width) * 100;
  //   const newY = (yOffset / blueprintRect.height) * 100;
    const newX = Math.max(0, Math.round((xOffset / blueprintRect.width) * 100) - 1);
    const newY = Math.max(0, Math.round((yOffset / blueprintRect.height) * 100) - 1);
  
    const isNewItem = !items.some((element) => element.id === droppedItem.id);

    const updatedItems = isNewItem
      ? [...items, { ...droppedItem, cssXCoordinate: newX, cssYCoordinate: newY }]
      : items.map((item) =>
          item.id === droppedItem.id
            ? { ...item, cssXCoordinate: newX, cssYCoordinate: newY }
            : item
        );

    setItems(updatedItems);

    if (!isNewItem) {
      saveState(updatedItems); // Only save state for movement
    }

    const updatedDevice = updatedItems.find((item) => item.id === droppedItem.id);
    if (updatedDevice) {
      await updateDeviceCoordinates(updatedDevice);
      await fetchFloorDevices();
      await fetchData();
    }
      if (isNewItem) {
        setOpenTooltipId(droppedItem.id);
      }

  },
  [items, saveState, updateDeviceCoordinates]
);

  const onDragOver = useCallback((e) => {
    e.preventDefault();
  }, []);


  const processedRows = useMemo(() =>
    Array.isArray(rows)
      ? rows.map((row) => ({
        ...row,
        id: row.id,
        DeviceName: row.name || "N/A",
        Type: typeof row.type === "object" && row.type
          ? row.type.name
          : row.type || "N/A",
        Status: row.status || "N/A",
        deviceMake: row.deviceMake || "N/A",
        serialNumber: row.serialNumber || "N/A",
        macAddress: row.macAddress || "N/A",
        ipAddress: row.ipAddress || "N/A",
        topicName: row.topicName || "N/A",
        cameraType: row.cameraType || 'N/A',
        streamUrl: row.streamUrl || 'N/A',
        videoLength: row.videoLength || 0,
      }))
      : [],
    [rows]
  );


  const undo = useCallback(async () => {
    if (undoStack.length > 0) {
      const previousState = undoStack[undoStack.length - 1];
      setRedoStack((prevStack) => [...prevStack, items]);
      setUndoStack((prevStack) => prevStack.slice(0, -1));
      setItems(previousState);


      if (Array.isArray(previousState)) {
        for (const device of previousState) {
          if (device.cssXCoordinate && device.cssYCoordinate) {
            try {
              await updateDeviceCoordinates(device);
            } catch (error) {
              console.error("Undo failed to update device:", error);
            }
          }
        }
      }


      // Refresh floor devices
      await fetchFloorDevices();
    }
  }, [undoStack, items, updateDeviceCoordinates]);


  const redo = useCallback(async () => {
    if (redoStack.length > 0) {
      const nextState = redoStack[redoStack.length - 1];
      setUndoStack((prevStack) => [...prevStack, items]);
      setRedoStack((prevStack) => prevStack.slice(0, -1));
      setItems(nextState);


      if (Array.isArray(nextState)) {
        for (const device of nextState) {
          if (device.cssXCoordinate && device.cssYCoordinate) {
            try {
              await updateDeviceCoordinates(device);
            } catch (error) {
              console.error("Redo failed to update device:", error);
            }
          }
        }
      }


      // Refresh floor devices
      await fetchFloorDevices();
    }
  }, [redoStack, items, updateDeviceCoordinates]);


  const renderDraggableItems = useMemo(
    () => {
      if (!expand) {
        return null; // Do not render if expand is false
      }


      return (
        <Box sx={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={processedRows}
            columns={columns.map((column) => ({
              ...column,
              renderCell: (params) => (
                <div
                  role="presentation"
                  draggable
                  onDragStart={(e) => onDragStart(e, params)}
                  className="sidbarFields"
                  style={{
                    pointerEvents: `${sideberItemDisabled ? "none" : ""}`,
                    cursor: `${sideberItemDisabled ? "none" : "move"}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {column.renderCell ? column.renderCell(params) : params.value}
                </div>
              ),
            }))}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            disableRowSelectionOnClick
            pagination
            hideFooter={processedRows.length === 0} // Hide footer and pagination if no rows
          />
        </Box>
      );
    },
    [expand, processedRows, columns, onDragStart, sideberItemDisabled] // Add `expand` as a dependency
  );




  const renderDraggableOnMap = useMemo(() => {
    if (isLoading || !Array.isArray(items)) return null; // Early return for loading or invalid items


    return items.map((item) => {
      if (item.cssYCoordinate === 0 || item.cssXCoordinate === 0) return null; // Skip invalid coordinates
      const itemImageSrc = (() => {
        switch (item.type?.name) {
          case "Camera":
            return cameraButton;
          case "Speaker":
            return SpeakerButton;
          case "Strobe Light":
            return strobeButton;
          case "Push-Button":
            return PushButton;
          case "Push Button Camera":
            return cameraPushButton
          case "Speaker Strobe":
            return speakerStrobe;
          case "Control Panel":
            return controlPanel;
          case "Installed Camera":
            return cameraInstalledFilled;
          case "Installed Speaker":
            return speakerInstalled;
          case "Collection Point":
            return collectionPoint;
          default:
            return "";
        }
      })();

      return (
        <div
          key={item.id}
          draggable
          role="presentation"
          onDragStart={(e) => onDraggedStart(e, item)}
          className="dropedItems"
          tabIndex={0}
          // aria-label={item.serialNumber}
          style={{
            position: "absolute",
            top: `${item.cssYCoordinate}%`,
            left: `${item.cssXCoordinate}%`,
            cursor: "move",
          }}
        >
          <AccessibleTooltip
            key={item.id}
            title={item.serialNumber}
              open={openTooltipId === item.id}

          >
            <img
              src={itemImageSrc}
              alt={`${item.type?.name || "Device"} (Serial: ${item.serialNumber})`}
              width="24"
              height="24"
              onMouseEnter={() => setOpenTooltipId(item.id)}
              onMouseLeave={() => setOpenTooltipId(null)}
            />
          </AccessibleTooltip>
          <span
            className="deleteIcon"
            aria-label={`Delete ${item.serialNumber}`}
            // onClick={(e) => deleteAddedItem(e, item)}
            onClick={(e) => {  setItemToDelete(item);  setOpenDeleteModal(true)}}
          ></span>
        </div>
      );
    });
  }, [items, onDraggedStart, isLoading, openTooltipId]);


  const fetchData = async () => {
    setSideberItemDisabled(true)
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/data/getDevicesMissingLocation`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });


      if (response.status === 200) {
        setRows(response.data);
        setSideberItemDisabled(false);
        handleImageLoad();
      }
    } catch (error) {
      console.error("Error making request:", error);
      setSideberItemDisabled(false)
    }
  };
  const fetchFloorDevices = async () => {
    try {
      if (!selectedFloor?.id) {
        console.error("Selected floor is undefined or missing id");
        return; // Exit early if selectedFloor is invalid
      }
      const token = JSON.parse(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/set-coord/data/location/${selectedFloor.id}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });


      if (response.status === 200) {
        setItems(
          response.data.map((device) => ({
            ...device,
            cssXCoordinate: device.cssXCoordinate,
            cssYCoordinate: device.cssYCoordinate,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching floor devices:", error);
    }
  };
  const updatedFloor = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/floor/floorList`; // Fetch all floors
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });


      if (response.status === 200) {
        const floors = response.data;
        // Find and set the specific floor by ID
        const selectedFloor = floors.find(
          (floor) => floor.id === parseInt(id, 10)
        );
        if (selectedFloor) {
          setSelectedFloor(selectedFloor); // Set the selected floor in state
        } else {
          console.warn(`Floor with ID ${id} not found`);
        }
      }
    } catch (error) {
      console.error("Error fetching floor details:", error);
    }
  };
  const deleteAddedItem = async (device) => {
    setItems((prevItems) => prevItems.filter((item) => item.id !== device.id));
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const decodedToken = jwtDecode(token);
      const formDataToSend = {
        id: device.id,
        name: device.name,
        cssXCoordinate: 0,
        cssYCoordinate: 0,
        type: device.type,
        deviceLocationName: selectedFloor?.floorName,
        deviceLocationId: null,
        triggeredByDeviceId: [0],
        deleted: false,
        createdAt: device.createdAt,
        modifiedAt: new Date().toISOString(),
        createdBy: device.createdBy,
        modifiedBy: decodedToken.userGuid,
        triggeredBy: device.triggeredBy,
        deviceMake: device.deviceMake,
        status: device.status,
        serialNumber: device.serialNumber,
        niagaraDeviceName:device.niagaraDeviceName,
        installed: device.installed,
        macAddress: device.macAddress,
        ipAddress: device.ipAddress,
        topicName: device.topicName,
        cameraType: device.cameraType,
        streamUrl: device.streamUrl,
        videoLength: device.videoLength,
      };
      const url = `${process.env.REACT_APP_DEVICE_API_URL}/v1/device/update/${device.id}`;
      const response = await axios({
        method: "PUT",
        url: url,
        data: formDataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });


      if (response.status === 200) {
        await fetchData();
        await fetchFloorDevices();
        setUndoStack([]);
        setRedoStack([]);
      }
    } catch (error) {
      console.error("Error deleting item:", error);


      // Revert optimistic update in case of an error// Add this because on delte item no rows showing
      setItems((prevItems) => [...prevItems, device]);
    }
  };

  useEffect(() => {
    if (id) {
      updatedFloor(id); // Pass ids or the specific floor ID
    }
  }, [id]);

  useEffect(() => {
    if (selectedFloor?.id) {
      fetchFloorDevices();
    }
  }, [selectedFloor]);


  const downloadblpHandler = () => {
    if(items.length > 0) {
      dispatch(downloadFloorBlueprint(selectedFloor?.id));
    }
  }


  return (
    <div className="deviceMangement_wrapper main_ele_wrapper">
      <div aria-live="polite" className="sr-only">
        {announcementMessage}
      </div>
      <div className="main_heading main_heading_addDevices">
        <h1 id="heading-title">Assign Devices</h1>
      </div>
      <div className="AddFloor addDeviceAddFloor addDevice_flor_drop">
                <h2>{selectedFloor?.floorName}</h2>

        <Box sx={{ minWidth: 340 }} className="floor-dropdown">
          <div className="undoRdoBtn" role="list">
            <div role="listitem">
              <button disabled={items.length <= 0} onClick={downloadblpHandler}>
                <img src={downloadButton} alt="" />
                <span>Download Blueprint</span>
              </button>
            </div>
            <div role="listitem">
              <button onClick={undo} disabled={undoStack.length === 0} data-testid="undo-button">
                <img src={undoImg} alt=""   />
                <span>UNDO</span>
              </button>
            </div>
            <div role="listitem">
              <button onClick={redo} disabled={redoStack.length === 0} data-testid="redo-button" >
                <img src={redoImg} alt=""  />
                <span>REDO</span>
              </button>
            </div>
          </div>
        </Box>
      </div>  
      <div className="inner_Wrapper addDeviceInnerWrppar"   >
        <div className="mapwrapper">
          <div style={{ width: "100%" }} className={`overlay-wrapper ${expand ? "active" : "inactive"}`}>
            <div
              role="presentation"
              className={`inner_addDevicewrapper ${expand ? "active" : "inactive"}`}
              onDrop={onDrop}
              onDragOver={onDragOver}
              ref={blueprintmainWrapperRef}
              style={{ width: "auto" }}
            >
              {!isLoading ? (
                <img
                src={selectedFloor?.floorImageUrl ? `${selectedFloor?.floorImageUrl}` : selectedFloor?.floorImageUrl || "No BluePrint"}
                  className={`main_bg_addv ${isTransitioning ? "fade-in" : ""}`}
                  alt="Blueprint"
                  ref={blueprintRef}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
              {!isLoading && renderDraggableOnMap}
            </div>
          </div>
          <div className={`inner_sideBar ${expand ? "active" : "inactive"}`}>
            <button
              className="excpBtn"
              aria-label="Device list panel"
              aria-expanded={expand ? "true" : "false"}
              onClick={() => setExpand(!expand)}
            ></button>
            <div className="table-overlay">
              {renderDraggableItems}
            </div>
          </div>
        </div>
        <div>
        <Footer floorMapRef={blueprintmainWrapperRef} expand={expand} isDynamicFooter={true} carouselItems={dynamicFooterList} />        
      </div>
      </div>
          <DeleteModal
              setOpenDeleteModal={setOpenDeleteModal}
              openDeleteModal={openDeleteModal}
              handleDelete={() => deleteAddedItem(itemToDelete)}
              deleteType="delteDevice"
          />
    </div>
  );
};


export default AddDevices;



